<script lang="ts" setup>
import { computed } from 'vue'
import { useDefaultFieldValues } from '@/components/form-builder/field-settings/useDefaultFieldValues'

interface Props {
  field: {
    allowTimeOfDaySelection: boolean
    defaultValue?: string | null
    uniqueKey: () => string
  }
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (
    e: 'modify-field',
    payload: {
      propertyKey: string
      fieldValue: boolean | string | null
      key: string
    },
  ): void
}>()

function toggleTimeOfDaySelection() {
  emit('modify-field', {
    propertyKey: 'allowTimeOfDaySelection',
    fieldValue: !props.field.allowTimeOfDaySelection,
    key: props.field.uniqueKey(),
  })
}

const { showDefaultValue, toggleDefaultValue } = useDefaultFieldValues(props.field)

const inputType = computed(() => (props.field.allowTimeOfDaySelection ? 'datetime-local' : 'date'))
</script>

<template>
  <vs-wrapper space="small">
    <v-checkbox
      :input-value="field.allowTimeOfDaySelection"
      label="Allow time of day input"
      @change="toggleTimeOfDaySelection"
    />

    <v-checkbox
      :input-value="showDefaultValue"
      label="Default Value"
      @change="toggleDefaultValue"
    />

    <div v-if="showDefaultValue">
      <vs-text-input v-model="field.defaultValue" :type="inputType" label="" />
    </div>
  </vs-wrapper>
</template>
